export default {
  Pending: "Pending",
  Published: "Published",
  Error: "Error",
  AwaitingApproval: "AwaitingApproval",
};
